// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__198li","inner":"styles_inner__39DTw","right":"styles_right__Fm3ZT","close":"styles_close__3vncJ","footer":"styles_footer__BlBCq"};